import {
  ChangeDetectionStrategy,
  Component,
  DOCUMENT,
  OnDestroy,
  OnInit,
  inject,
  input,
  output,
} from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "vw-modal",
  templateUrl: "./modal.component.html",
})
export class ModalComponent implements OnInit, OnDestroy {
  readonly title = input<string>();
  readonly closeable = input<boolean>();

  readonly close$ = output<void>();

  private doc = inject(DOCUMENT);

  ngOnInit() {
    const curOpen =
      Number.parseInt(document.body.dataset.openModals || "0", 10) | 0;
    document.body.dataset.openModals = (curOpen + 1).toFixed(0);
    this.doc.body.classList.add("modal-open");
  }

  ngOnDestroy(): void {
    const curOpen =
      Number.parseInt(document.body.dataset.openModals || "0", 10) | 0;
    const newOpen = Math.max(curOpen - 1, 0);
    if (newOpen === 0) {
      delete this.doc.body.dataset.openModals;
      this.doc.body.classList.remove("modal-open");
    } else {
      document.body.dataset.openModals = newOpen.toFixed(0);
    }
  }

  close(): void {
    if (this.closeable()) {
      // TODO: The 'emit' function requires a mandatory void argument
      this.close$.emit();
    }
  }
}
